import React from 'react';
import FadeIn from './FadeIn';
import heroPhoto from '../assets/images/IMG_1053.JPG';

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero__card">
          <img src={heroPhoto} alt="" className="hero__bg" aria-hidden="true" />
          <FadeIn className="hero__meta-wrap">
            <div className="hero__meta">
              <span>LLC 2026 · OCT. 10, 2026 · BEST WESTERN PLUS, DOUALA</span>
              <span>official@linkedinlocalcameroon.com</span>
            </div>
          </FadeIn>
          <FadeIn className="hero__content" delay={1}>
            <h1 className="hero__title">
              Rise locally,<br />Lead globally
            </h1>
            <p className="hero__desc">
              Positioning Cameroonian talents for the world. Join 2,000+ delegates,
              10+ international speakers, and Cameroon's most ambitious professionals
              for one transformational day.
            </p>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '32px' }}>
              <span className="hero__stat-chip">2,000+ Delegates</span>
              <span className="hero__stat-chip">10+ Speakers</span>
              <span className="hero__stat-chip">10 Award Categories</span>
            </div>
            <a href="#tickets" className="btn-primary">
              Early bird tickets &#8599;
            </a>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
